import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { shelvesEventComposer } from '@bibliocommons/analytics-event-composers';
import ShelfLink from '../../shelves/ShelfLink';

import './ShelfAvailabilityTitle.scss';

function handleBackToShelvesClick() {
  sendAnalyticsEvents(shelvesEventComposer.composeBackToShelvesEvent());
}

export class ShelfAvailabilityTitle extends React.PureComponent {
  getShelfUrl() {
    const { userId, shelfName } = this.props;
    return `/v2/users/${userId}/shelves/${shelfName}`;
  }

  renderShelfTitleContent() {
    const { shelfName } = this.props;

    return (
      shelfName && (
        <h1 className="shelf-title">
          <FormattedMessage id={`Search.shelfTitle.${shelfName}`} />
        </h1>
      )
    );
  }

  render() {
    const { userId, shelfName } = this.props;
    return (
      <div className="row cp-shelf-availability-title">
        <div className="col-12 col-xs-12 shelf-availability-title-block" aria-atomic="true">
          <div className="shelf-title-header">
            {this.renderShelfTitleContent()}
            <ShelfLink userId={userId} shelfName={shelfName} handleClick={handleBackToShelvesClick}>
              <FormattedMessage id="back_to_shelf_link_text" />
            </ShelfLink>
          </div>
        </div>
      </div>
    );
  }
}

ShelfAvailabilityTitle.propTypes = {
  userId: PropTypes.number.isRequired,
  shelfName: PropTypes.string.isRequired
};

export default ShelfAvailabilityTitle;
